import React from "react";
import { Button, ButtonProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

interface CancelButtonProps extends Omit<ButtonProps, "type" | "onClick"> {
  to: string;
  label?: string;
  confirmDirty?: boolean;
  isDirty?: boolean;
  hideIcon?: boolean;
}

const CancelButton: React.FC<CancelButtonProps> = ({
  to,
  label = "Cancel",
  confirmDirty = false,
  isDirty = false,
  hideIcon = false,
  variant = "outlined",
  ...rest
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (confirmDirty && isDirty) {
      const ok = window.confirm("Discard changes?");
      if (!ok) return;
    }
    navigate(to);
  };
  return (
    <Button
      type="button"
      variant={variant}
      startIcon={hideIcon ? undefined : <CloseIcon />}
      onClick={handleClick}
      {...rest}
    >
      {label}
    </Button>
  );
};

export default CancelButton;
